import { render, staticRenderFns } from "./InboxName.vue?vue&type=template&id=1e951c42&scoped=true&"
import script from "./InboxName.vue?vue&type=script&lang=js&"
export * from "./InboxName.vue?vue&type=script&lang=js&"
import style0 from "./InboxName.vue?vue&type=style&index=0&id=1e951c42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e951c42",
  null
  
)

export default component.exports